import config from '../config';
import * as actions from '../actions/materials';
import fetch from 'cross-fetch';
import store from 'store2';
import { addNotification as notify } from 'reapop';
import { push } from 'react-router-redux';
import { path } from "ramda";

export function getMaterialsList() {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetchUrl(`materials-inventory`)
        .then((response) => {
          return response.json();
        })
        .then(materials => {
          if (materials) {
            fetchUrl(`vendor`)
              .then((response) => {
                return response.json();
              })
              .then(vendors => {
                const list = materials.map((material) => {
                  const vendor = vendors.find((vendor) => vendor.id === material.vendor_id);
                  return {
                    ...material,
                    vendor: vendor ? vendor.name : material.vendor_id
                  };
                });
                dispatch(actions.getMaterialsList({ list }));
              })
              .catch(e => {
                const list = materials.map((material) => ({
                  ...material,
                  vendor: material.vendor_id,
                }));
                dispatch(actions.getMaterialsList({ list }));
              })
          }
        })
        .catch(response => {
          dispatch(actions.getMaterialsList({ list: [] }));
          dispatch(notify({
            title: 'Get Materials List',
            message: 'Failed to get materials list',
            status: 'error',
            position: 'tr',
            dismissible: true,
            dismissAfter: 3000
          }));
        });
    }
  }
};

export function getMaterialsListByVendor(id) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetchUrl(`materials-inventory/vendor/${id}`)
        .then((response) => {
          return response.json();
        })
        .then(materials => {
          if (materials) {
            fetchUrl(`vendor/${id}`)
              .then((response) => {
                return response.json();
              })
              .then(vendor => {
                const list = materials.map((material) => {
                  return {
                    ...material,
                    vendor: vendor ? vendor.name : material.vendor_id
                  };
                });
                dispatch(actions.getMaterialsList({ list, vendor: vendor.name }));
              })
              .catch(e => {
                const list = materials.map((material) => ({
                  ...material,
                  vendor: material.vendor_id,
                }));
                dispatch(actions.getMaterialsList({ list, vendor: null }));
              })
          }
        })
        .catch(response => {
          dispatch(actions.getMaterialsList({ list: [], vendor: null }));
          dispatch(notify({
            title: 'Get Materials List',
            message: 'Failed to get materials list',
            status: 'error',
            position: 'tr',
            dismissible: true,
            dismissAfter: 3000
          }));
        });
    }
  }
};

export function getMaterial(id) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetchUrl(`materials-inventory/${id}`)
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(actions.getMaterial({ currentMaterial: json }));
          }
        })
        .catch(response => {
          dispatch(notify({
            title: 'Get Material',
            message: 'Failed to get material',
            status: 'error',
            position: 'tr',
            dismissible: true,
            dismissAfter: 3000
          }));
        });
    }
  }
};

export function addMaterial(data) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetchUrl(`materials-inventory`, 'POST', data)
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json.detail && !json.added) {
            dispatch(notify({
              title: 'Add New Material',
              message: JSON.stringify(json.detail),
              status: 'error',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
          } else if (json) {
            dispatch(push('/pages/materials'));
            dispatch(notify({
              title: 'Add New Material',
              message: 'Material added successfully',
              status: 'success',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
          }
        })
        .catch(response => {
          dispatch(notify({
            title: 'Add New Material',
            message: 'Failed to add material',
            status: 'error',
            position: 'tr',
            dismissible: true,
            dismissAfter: 3000
          }));
        });
    }
  }
};

export function updateMaterial(id, data) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetchUrl(`materials-inventory/${id}`, 'PUT', data)
        .then((response) => {
          return response.json();
        })
        .then(json => {
          const error = path(['detail'], json);
          if (error) {
            dispatch(notify({
              title: 'Update Material',
              message: JSON.stringify(error),
              status: 'error',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
          }
          else {
            dispatch(notify({
              title: 'Update Material',
              message: 'Material has been updated successfully',
              status: 'success',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
          }
          setTimeout(function () {
            window.location.reload();
          }, 1000);
        })
        .catch(response => {
          dispatch(notify({
            title: 'Update Material',
            message: 'Failed to update material',
            status: 'error',
            position: 'tr',
            dismissible: true,
            dismissAfter: 3000
          }));
        });
    }
  }
};

export function deleteMaterial(data) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetchUrl(`materials-inventory/${data.id}`, 'DELETE')
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(push('/pages/materials'));
            dispatch(notify({
              title: 'Delete Material',
              message: 'Material deleted successfully',
              status: 'success',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
          }
        })
    }
  }
};

export function importMaterials(data) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/materials-inventory/upload`, {
        method: 'POST',
        body: data,
        headers: {
          'Authorization': `bearer ${store.get('user').api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          dispatch(push('/pages/materials'));
          dispatch(notify({
            title: 'Import Materials',
            message: `Materials imported successfully.
              Added - ${json.added_rows}, updated - ${json.updated_rows}.
              ${json.not_valid_rows ? `Invalid - ${json.not_valid_rows}.` : ''}`,
            status: 'success',
            position: 'tr',
            dismissible: true,
            dismissAfter: 3000
          }));
        })
        .catch(response => {
          dispatch(notify({
            title: 'Import Materials',
            message: 'Failed to import materials',
            status: 'error',
            position: 'tr',
            dismissible: true,
            dismissAfter: 3000
          }));
        });
    }
  }
}

const fetchUrl = (url, method = 'GET', data) => {
  return fetch(`${config.apiEndpoint}/${url}`, {
    method,
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `bearer ${store.get('user').api_token}`
    },
    credentials: 'same-origin'
  })
};



// WEBPACK FOOTER //
// ./src/api/materials.js